import React from "react";
import { Link } from "@mui/material";
import "./Footer.css"; // Import the CSS file

const Footer = () => {
  return (
    <div className="footer">
      <p>
        Made with ❤️ by{" "}
        <Link
          href="https://buggasoftware.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Bugga Software
        </Link>
      </p>
    </div>
  );
};

export default Footer;
